export const COOKIE_CONSENT_NAME = "flow_cookie_consent";
export const COOKIE_CONSENT_MAX_AGE = 60 * 60 * 24 * 180;

export type CookieConsentValue = "accepted" | "rejected";

export function parseCookieConsent(
	cookieHeader: string,
): CookieConsentValue | null {
	const entry = cookieHeader
		.split(";")
		.map((part) => part.trim())
		.find((part) => part.startsWith(`${COOKIE_CONSENT_NAME}=`));

	if (!entry) {
		return null;
	}

	const value = entry.slice(COOKIE_CONSENT_NAME.length + 1);

	if (value === "accepted" || value === "rejected") {
		return value;
	}

	return null;
}

export function createCookieConsentString(value: CookieConsentValue) {
	return [
		`${COOKIE_CONSENT_NAME}=${value}`,
		"Path=/",
		`Max-Age=${COOKIE_CONSENT_MAX_AGE}`,
		"SameSite=Lax",
		process.env.NODE_ENV === "production" ? "Secure" : "",
	]
		.filter(Boolean)
		.join("; ");
}
